
import {Component, Vue} from "vue-property-decorator";
import {Getter} from "vuex-class";
import { formRules } from "@/utils/formRules";
import AddressGeo from "@/components/AddressGeo.vue";

@Component({
  components: { AddressGeo },
})
export default class CreateBuilding extends Vue {

    @Getter private isAdmin: boolean;
    @Getter private isMobile: boolean;
    @Getter private envCompanyId: number | null;

    private showDialog: boolean = false;
    private buildingData: any = {
      name: "",
      urmetCredential: null,
    };
    private valid: boolean = true;
    private loading: boolean = false;
    private displayAdvancedOptions: boolean = false;
    private rules = formRules;

    private init(): void {
        this.showDialog = false;
    }

    private toggleAdvancedOptions(): void {
        this.buildingData.urmetCredential = !this.displayAdvancedOptions ? {} : null;
        this.displayAdvancedOptions = !this.displayAdvancedOptions;
    }

    private createBuilding(): void {
        this.loading = true;
        this.$store.dispatch("buildings/createBuilding", {
            companyId: this.envCompanyId,
            building: this.buildingData,
        }).then((res) => {
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$t("Buildings.added"),
            });
            this.$emit("reset");
            this.init();
        }).catch((err) => {
            const error: string = err.response?.data?.message;
            const splitError: string[] = error.split("--");
            this.$store.commit("alerts/displayError", {
                msg: this.$t("Buildings." + `${splitError[0]}`, {
                    building : splitError[1],
                }),
            });
        }).finally(() => {
            this.loading = false;
        });
    }
}
